<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="結束分享"
    cancelBtnText="拒絕"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <div class="subheading">{{dialogText}}</div>
    <v-progress-linear
      v-if="countdownProgress"
      v-model="countdownPercentage"
      color="secondary" />
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '',
    showConfirmBtn: true,
    showCancelBtn: true,
    waitingTime: 0,
    countdownProgress: true
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      fudaoDto: state => state.fudaoDto,
      fudaoSession: state => state.fudaoSession,
      responseTimeout: state => state.responseTimeout
    }),

    isSelfInvite() {
      return this.fudaoDto.teacher.Id === this.userid;
    },

    countdownPercentage() {
      return Math.round(this.waitingTime/(this.responseTimeout/1000) * 100);
    }
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    },

    waitingTime(value) {
      if (value < this.responseTimeout/1000) {
        return;
      }

      this.stopCountdownProgress();
      this.sentNoResponse();
    }
  },

  mounted() {
    this.$eventBus.$on(FudaoEvent.StudentEndSessionInvitationReceived, this.onStudentEndSessionInvitationReceived);
  },

  beforeDestroy() {
    this.$eventBus.$off(FudaoEvent.StudentEndSessionInvitationReceived, this.onStudentEndSessionInvitationReceived);
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoDto.id !== domainEvent.entityId;
    },

    stopCountdownProgress() {
      clearInterval(this._countdownTimeInterval);
      this.countdownProgress = false;
    },

    open() {
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.TeacherEndSessionInvitationCanceled, this.onTeacherEndSessionInvitationCanceled);
      this.$eventBus.$off(FudaoEvent.StudentEndSessionInvitationNoReponse, this.onStudentEndSessionInvitationNoReponse);
      this.$eventBus.$off(FudaoEvent.FudaoSessionEnded, this.onFudaoSessionEnded);
      this.$eventBus.$off(FudaoEvent.FudaoSessionFailed, this.onFudaoSessionFailed);

      this.stopCountdownProgress();
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      if (!this.isStudent || this.fudaoDto.teacher.Id === this.userid) {
        this.addAlert({level: 'error', content: '無法結束分享: 角色錯誤'});
        this.dialog = false;
        return;
      }
      this.stopCountdownProgress();
      this.loading = true;
      this.showCancelBtn = false;
      await fudaoAppService.acceptFudaoEndSessionInvitionAsync(this.fudaoDto.id, this.fudaoSession);
    },

    async cancel() {
      this.stopCountdownProgress();
      await fudaoAppService.rejectFudaoEndSessionInvitionAsync(this.fudaoDto.id, this.fudaoSession);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseFudaoEndSessionInvitionAsync(this.fudaoDto.id, this.fudaoSession);
    },

    // events ---------------------------------------------------

    onTeacherEndSessionInvitationCanceled(domainEvent) {
      if (this.isSelfInvite || this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '老師取消邀請結束分享'});
      this.dialog = false;
    },

    onStudentEndSessionInvitationReceived(domainEvent) {
      if (this.isSelfInvite || this.isDifferentFudao(domainEvent)) {
        return;
      }

      this.$eventBus.$on(FudaoEvent.TeacherEndSessionInvitationCanceled, this.onTeacherEndSessionInvitationCanceled);
      this.$eventBus.$on(FudaoEvent.StudentEndSessionInvitationNoReponse, this.onStudentEndSessionInvitationNoReponse);
      this.$eventBus.$on(FudaoEvent.FudaoSessionEnded, this.onFudaoSessionEnded);
      this.$eventBus.$on(FudaoEvent.FudaoSessionFailed, this.onFudaoSessionFailed);

      let sessionType = domainEvent.body.SessionType;
      switch (sessionType) {
        case 'TeacherVideo':
          this.dialogText = '是否結束視訊分享?';
          break;

        case 'Audio':
          this.dialogText = '是否結束音訊分享?';
          break;

        case 'Whiteboard':
          this.dialogText = '是否結束白板分享?';
          break;
      }

      this.dialog = true;

      this._countdownTimeInterval = setInterval(() => {
        this.waitingTime++;
      }, 1000);
    },

    onStudentEndSessionInvitationNoReponse(domainEvent) {
      if (this.isSelfInvite || this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '回應逾時'});
      this.dialog = false;
    },

    onFudaoSessionEnded(domainEvent) {
      this.dialog = false;
    },

    onFudaoSessionFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請結束分享發生錯誤: ' + errMsg});
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
